import { ADD_SECTION, DELETE_SECTION, GET_SECTION,UPDATE_SECTION } from '../types'

const INITIAL_STATE = {
  addSection: [],
  deleteSection: [],
  allSection: [],
  updateSection:[],
}

const sectionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ADD_SECTION:
      return {
        ...state,
        addSection: payload.data,
      }
    case GET_SECTION:
      return {
        ...state,
        allSection: payload.data,
      }
    case DELETE_SECTION:
      return {
        ...state,
        deleteSection: payload.data,
      }
      case UPDATE_SECTION:
        return {
          ...state,
          updateSection: payload.sectionId,
        }
    default:
      return state
  }
}

export default sectionReducer
